import React from 'react'
import Loader from '../../loaders'
import { strings } from '../../../localization/strings'
import { Typography, Button } from '@material-ui/core/index'
import { TextField } from '@material-ui/core'
import { MailLinkWrapper } from '../../components/linkWrappers'
import MailIcon from '@material-ui/icons/Mail'
import logotipoPudo from '../../../assets/icons/logo-pudo-en-tu-camino.png'

const SHOPIFY_URL_TEMPLATE = process.env.REACT_APP_SHOPIFY_APP

class Component extends React.Component {
    state = {
        loader: false,
        shopName: '',
        enableInstallApp: false,
        shopifyInstallUrl: '',
    }

    componentDidMount() {}

    updateShopName = (ev) => {
        let shopName = ev.target.value

        this.setState({ shopName: shopName })
        if (shopName != null && shopName.length > 0) {
            let matches =
                /(https?:\/\/)?(?<domain>[-a-zA-Z0-9@%_\\+~#=]{1,256})\.myshopify[.*]/.exec(
                    shopName
                )
            let shopNameToInstall = shopName
            if (matches && matches.groups && matches.groups.domain) {
                shopNameToInstall = matches.groups.domain
            }
            let validShopName = /^[-a-zA-Z0-9@%_\\+~#=]{1,256}$/.exec(
                shopNameToInstall
            )
            if (validShopName) {
                let shopifyInstallUrl = SHOPIFY_URL_TEMPLATE.replace(
                    '{{shopName}}',
                    shopNameToInstall
                )
                this.setState({
                    shopifyInstallUrl: shopifyInstallUrl,
                    enableInstallApp: true,
                })
            } else {
                this.setState({
                    shopifyInstallUrl: '',
                    enableInstallApp: false,
                })
            }
        } else {
            this.setState({ shopifyInstallUrl: '', enableInstallApp: false })
        }
    }

    render() {
        if (this.state.loader) return <Loader />

        return (
            <div
                style={{
                    maxWidth: 350,
                    margin: 'auto',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <img src={logotipoPudo} style={{width:'200px', margin:'30px auto 0'}} onClick={() => this.props.history.push('/')} />
                <div style={{ paddingTop: 50 }} />

                <Typography
                    variant="h6"
                    color="textPrimary"
                    style={{ flexGrow: 1, marginBottom: 20 }}
                >
                    {strings.shopifyHelpInstallInstructions}
                </Typography>

                <TextField
                    placeholder={strings.shopifyHelpShopNamePlaceholder}
                    style={{ maxWidth: 340, marginBottom: 20 }}
                    fullWidth
                    onChange={this.updateShopName}
                    value={this.state.shopName}
                />

                <Button
                    color="primary"
                    variant="contained"
                    target="_blank"
                    href={this.state.shopifyInstallUrl}
                    disabled={!this.state.enableInstallApp}
                >
                    Instalar la app
                </Button>

                <div style={{ paddingTop: 50 }} />

                <Typography
                    variant="h6"
                    color="textPrimary"
                    style={{ flexGrow: 1 }}
                >
                    {strings.shopifyHelpAfterInstallInstructions.replace(
                        '{{mailAddress}}',
                        strings.shopifyHelpAfterInstallMailAddress
                    )}
                </Typography>
                <Button color="primary" size="small">
                    <MailLinkWrapper
                        mail={strings.shopifyHelpAfterInstallMailAddress}
                        subject={strings.shopifyHelpAfterInstallMailSubject}
                        body={
                            this.state.shopName
                                ? strings.shopifyHelpAfterInstallMailBody.replace(
                                      '{{shopName}}',
                                      this.state.shopName
                                  )
                                : strings.shopifyHelpAfterInstallMailBodyWithoutShopName
                        }
                    >
                        <MailIcon color="primary" style={{ fontSize: 64 }} />
                    </MailLinkWrapper>
                </Button>
            </div>
        )
    }
}

export default Component
